import { render, staticRenderFns } from "./consultationRegistration.vue?vue&type=template&id=a3fb05b6&scoped=true&"
import script from "./consultationRegistration.vue?vue&type=script&lang=js&"
export * from "./consultationRegistration.vue?vue&type=script&lang=js&"
import style0 from "./consultationRegistration.vue?vue&type=style&index=0&id=a3fb05b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fb05b6",
  null
  
)

export default component.exports